import { api } from "../services/axios"

export const ObterSugestoesTema = async (idUsuario) => {
  const { data, status } = await api.get(`/optigenerator/gerar-sugestao-tema/${idUsuario}`)
  return { data, status }
}

export const ObterReferencias = async (tema,descricao,keyword) => {
  const { data, status } = await api.get(`/optigenerator/obter-referencias/${tema}/${descricao}/${keyword}`)
  return { data, status }
}

export const ObterAvaliacaoPalavraChave = async (keyword) => {
  const { data, status } = await api.get(`/optigenerator/gerar-palavras-chaves/${keyword}`)
  return { data, status }
}

export const GerarConteudoImagem = async(request) =>{
  const {data,status} = await api.post('/optigenerator/gerar-conteudo-imagem',request)
  return {data,status}
}

export const GerarImagemUsuario = async(prompt) => {
  const {data, status} = await api.post(`/optigenerator/gerar-imagem-usuario?prompt=${encodeURIComponent(prompt)}`);
  return {data, status};
}

export const AlterarTomParagrafo = async(obj) => {
  const {data, status} = await api.post(`/optigenerator/alterar-tom-paragrafo`, obj);
  return {data, status};
}

export const AlterarParagrafo = async(obj) => {
  const {data, status} = await api.post(`/optigenerator/alterar-paragrafo`, obj);
  return {data, status};
}